module.exports = __webpack_public_path__ + "img/1532794710.c87fadbe.jpg";